/** Shared classes for dashboard registration / notice modals (matches auth design). */
export const modalShell =
    'relative overflow-hidden rounded-[22px] border border-[#efe6f1] bg-white shadow-[0_20px_60px_rgba(136,22,122,0.12)]';

export const modalBody = 'px-5 py-6 sm:px-8 sm:py-8';

export const modalTitle =
    'font-[AvertaStd-Semibold] text-[22px] leading-tight text-ryd-headerTextPrimary sm:text-[24px]';

export const modalSubtitle = 'mt-1.5 text-[13px] leading-relaxed text-[#8b9aab] sm:text-[14px]';

export const modalLabel = 'mb-1.5 block text-[13px] font-semibold text-ryd-headerTextPrimary';

export const modalField =
    'w-full rounded-[12px] border border-[#E8E0EC] bg-white px-4 py-3 text-[14px] text-[#334155] outline-none transition placeholder:text-[#94a3b8] focus:border-ryd-primary focus:ring-2 focus:ring-ryd-primary/15';

export const modalRow = 'grid gap-4 sm:grid-cols-2';

export const modalStack = 'space-y-4';

export const modalCloseBtn =
    'absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full text-[#94a3b8] transition hover:bg-[#F8F5FA] hover:text-ryd-primary sm:right-5 sm:top-5';

export const modalPrimaryBtn =
    'inline-flex w-full items-center justify-center gap-2 rounded-[14px] bg-gradient-to-r from-[#7A2F78] via-ryd-primary to-[#E05AAE] px-5 py-3.5 text-[15px] font-semibold text-white shadow-md transition hover:scale-[1.01] disabled:cursor-not-allowed disabled:opacity-60';

export const modalSecondaryBtn =
    'inline-flex w-full items-center justify-center rounded-[14px] border border-[#E8E0EC] bg-white px-5 py-3.5 text-[15px] font-semibold text-[#476788] transition hover:border-ryd-primary hover:text-ryd-primary';

export const modalDangerBtn =
    'inline-flex w-full items-center justify-center gap-2 rounded-[14px] bg-red-600 px-5 py-3.5 text-[15px] font-semibold text-white shadow-md transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60';

export const modalNotice =
    'rounded-[14px] border border-amber-200/80 bg-[#FFF8EB] px-4 py-3 text-[13px] leading-relaxed text-[#7a5c20]';

export const modalAlert =
    'rounded-[14px] border border-red-200 bg-red-50 px-4 py-3 text-[13px] leading-relaxed text-red-700';
